// extracted by mini-css-extract-plugin
export default {"container":"jY-z","title":"kY-z","link":"lY-z"};